export default "__VITE_ASSET__BPZrU2B6__"